import React from 'react';
import './App.css';
import {HomePage} from "./pages/HomePage"
import AppTheme from "./themes/AppTheme";

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

datadogRum.init({
    applicationId: 'cfe6f920-a6dd-4a92-9ed2-89a5a7669a27',
    clientToken: 'pub300188b9ed6665a22c79d9fdd61c4ab0',
    site: 'us5.datadoghq.com',
    service: 'junkyard-ui',
    env: 'prod',
    version: '1.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    plugins: [reactPlugin({ router: false })],
});

function App() {

  return (
    <AppTheme>
      <HomePage />
    </AppTheme>
  );
}

export default App;
